import { CanActivateFn, Router } from "@angular/router";
import { inject } from "@angular/core";
import { SubscriptionService, UserService } from "@/_services";
import { isAsapAccount } from "@/_models/account.interface";
import { ISubscription } from "@/_models";
import { map, switchMap } from "rxjs/operators";
import { of } from "rxjs";

export const activeTrialOnlyGuard: CanActivateFn = (route, state) => {
    const subscriptionService = inject(SubscriptionService);
    const userService = inject(UserService);
    const router = inject(Router);

    return subscriptionService.subscriptionData().pipe(
        switchMap((subscription: ISubscription) => {
            if (!subscription.isTrialActive()) {
                router.navigateByUrl("/home");
                return of(false);
            }

            return userService.getCurrentUserAsync().pipe(
                switchMap((user) => {
                    if (isAsapAccount(user.account)) {
                        router.navigateByUrl("/home");
                        return of(false);
                    }
                    return of(true);
                }),
            );
        }),
    );
};
